<template>
	<div class="tabWrapper statementsItems">
		<div class="rowTabHead">
			<div class="tabTitle" v-if="isGeneralTitle">{{ textGeneralTitle }}</div>
		</div>
		<div
				class="main"
				v-if="!isStatementCreateForm"
		>
			<main-table-all-back
					:flag="flag"
					:headers="getHeaders"
					:filtersList="statementsDefaultFilters"
					:list="statementsDefaultRows"
					:defaultOrder="statementsDefaultOrder"
					:defaultSort="statementsDefaultSort"

					:totals="statementsDefaultTotals"
					:total-pages="statementsDefaultTotal"
					:limit-pages="statementsDefaultLimit"
					:pages="[ 15, 50, 100, 200, 500, 'All' ]"
					@updateClickButton="onClickButton"
					@updateList="onList"
					@updateRefreshFilters="onUpdateFilters(defaultFilter)"
					:is-create="false"
					:is-settings="false"
					:is-export="isExport()"
					is-export-permissions
					@updateExport="onExport"
					:department_id="user.department_id"
			></main-table-all-back>
		</div>

		<statement-new-item
				v-if="isStatementNewItem"
		></statement-new-item>

		<preload v-if="isPreloader"></preload>

		<!--		onManager-->
		<manager-statements-form
				v-if="isManagerStatementsForm"
				:isEdit="isEdit"
				:managerStatementsItem="managerStatementsItem"
				:managerStatementsMonth="managerStatementsMonth"
				:managerStatementsDepartments="managerStatementsDepartments"
				@updateCloseDialog="onManagerCloseDialog"
		></manager-statements-form>
		<!--		onManager-->

		<!--		Other-->
		<other-statements-form
				v-if="isOtherStatementsForm"
				:isEdit="isEdit"
				:otherStatementsItem="otherStatementsItem"
				:managerStatementsMonth="statementsDefaultMonth"
				:managerStatementsDepartments="statementsDefaultDepartments"
				@updateCloseDialog="onOtherCloseDialog"
		></other-statements-form>
		<!--		Other-->

		<!--		onDispatchers-->
		<statement-create-form
				v-if="isStatementCreateForm"
				@backFromCreate="onBackFromCreate"
				@backToMainTB="onBackToMainTB"
		></statement-create-form>
		<!--		onDispatchers-->

		<!--		onSafety-->

		<safety-statements-create
				v-if="isCreateStatements"
				@updateClose="onSafetyCloseDialog(false)"
				@updateView="onView(true)"
		></safety-statements-create>

		<safety-statements-view
				v-if="isSafetyStatementsView"
				@updateCloseViewDialog="onView(false)"
		></safety-statements-view>

		<!--		onSafety-->
	</div>
</template>

<script>
import { accountTabMyStatementsItems } from "@/pages/Account/constants";
// import ItemInfoRow from "@/shared/ItemInfoRow/ItemInfoRow.vue";
import StatementNewItem from "@/pages/Account/Drawers/StatementNewItem.vue";
import ManagerStatementsForm
from "@/components/Accounting/ManagerStatements/ManagerStatementsForm/ManagerStatementsForm.vue";
import { mapActions, mapGetters } from "vuex";
import Preload from "@/shared/Preload/Preload.vue";
import StatementCreateForm
from "@/components/Accounting/dispatchers-st-ts/statements-create-form/statements-create-form.component.vue";

import SafetyStatementsCreate
from "@/components/Accounting/SafetyStatements/SafetyStatementsCreate/SafetyStatementsCreate";
import SafetyStatementsView
from "@/components/Accounting/SafetyStatements/SafetyStatementsView/SafetyStatementsView";
import MainTableAllBack from "@/shared/MainTableAllBack/MainTableAllBack.vue";
import OtherStatementsForm from "@/components/Accounting/OtherStatements/OtherStatementsForm/OtherStatementsForm.vue";
import { PERMISSIONS, TAB } from "@/constants/constants";
import { getPermissionsMod } from "@/helper/getPermissionsMod";

export default {
	name: "StatementsAll",
	components: {
		OtherStatementsForm,
		MainTableAllBack,
		StatementCreateForm,
		Preload,
		ManagerStatementsForm,
		StatementNewItem,
		SafetyStatementsCreate,
		SafetyStatementsView,
	},
	props: {
		id: [ String, Number ],
		isGeneralTitle: {
			type: Boolean,
			default: true,
		},
		textGeneralTitle: {
			type: String,
			default: "Statements Items",
		},
		user: Object,
	},
	computed: {
		...mapGetters([
			"managerStatementsMonth",
			"managerStatementsDepartments",
			"managerStatementsItem",
			"statementsDefaultRows",
			"statementsDefaultLimit",
			"statementsDefaultOrder",
			"statementsDefaultSort",
			"statementsDefaultSum",
			"statementsDefaultTotal",
			"statementsDefaultTotals",
			"statementsDefaultFilters",
			"statementsDefaultDepartments",
			"statementsDefaultMonth",
			"permissionsDefault",
		]),
		getHeaders() {
			return accountTabMyStatementsItems;
		},

	},
	data: () => ({
		flag: TAB.USER_TAB_ST_ST__ALL,

		isPreloader: false,
		isOtherStatementsForm: false,
		isManagerStatementsForm: false,
		isStatementNewItem: false,
		isStatementCreateForm: false,
		isCreateStatements: false,
		isSafetyStatementsView: false,

		bonus: null,
		charge: null,
		salary: null,
		total: null,

		defaultFilter: null,
		activeTableFilters: null,

		otherStatementsItem: null,
		set: null,
		start: false,
	}),

	methods: {
		...mapActions([
			'getManagerStatements',
			'getManagerStatementsFilters',
			'getStatementsDefaultList',
			'getStatementsDefaultFilters',
			'getStatementsDefaultCreate',
			'onExportLink',
		]),
		async onExport(values) {
			values.id = this.id;
			values.setting = [
				"id",
				"month",
				"created",
				"department",
				"bonus",
				"charge",
				"manager",
				"salary",
				"total",
			];

			await this.onExportLink({ values, requestKey: 'statements-all', isSetting: 1 });
		},
		isExport() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.ACCOUNT, PERMISSIONS.ACCOUNT_USERS, PERMISSIONS.ACCOUNT_ST_TS, PERMISSIONS.EXPORT ];
			return getPermissionsMod({ list, path });
		},
		async onUpdateFilters(filters, isWithoutPayload, isWithoutFilters) {
			// Добавляем id в объект filters
			filters.id = this.id;
			if (!isWithoutPayload) this.isPreloader = true;
			await this.getStatementsDefaultList(filters);
			if (!isWithoutFilters) await this.getStatementsDefaultFilters(filters);
			if (!isWithoutPayload) this.isPreloader = false;
		},

		async onList(values) {
			this.isPreloader = true;
			const { value, flag } = values;
			// сохраняем выбранные фильтры отдельно
			this.activeTableFilters = value;

			switch (flag) {
				case "sorting":
					await this.getStatementsDefaultList(value);
					this.isPreloader = false;
					break;
				case "page":
					await this.onUpdateFilters(value, 1, 1);
					this.isPreloader = false;
					break;
				default:

					if (this.start) {
						await this.onUpdateFilters(value, 1);
					} else {
						const filters = { id: this.id };

						await this.onUpdateFilters(filters, 1);
						this.start = true;
					}
					this.isPreloader = false;

			}
		},

		async onClickButton({ key, item }) {
			console.info('%c [  item 3 ] ', 'color:#bada55', typeof item, item );
			console.info('%c [  key  ] ', 'color:#bada55', typeof key, key );
		},

		setNewItem(e, id, name) {
			this.$emit('updateNewItem', { e, id, name });
		},
		funToLocaleString(number) {
			return number.toLocaleString("ru-RU", {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
		},
	},
	mounted() {

	},

	watch: {
		statementsDefaultSum(value, oldValue) {
			if (value !== oldValue) {
				const { sum_bonus, sum_charge, sum_salary, sum_total } = value;

				this.bonus = this.funToLocaleString(Number(sum_bonus));
				this.charge = this.funToLocaleString(Number(sum_charge));
				this.salary = this.funToLocaleString(Number(sum_salary));
				this.total = this.funToLocaleString(Number(sum_total));
			}
		},
		managerStatementsItem(value, oldValue) {
			if (value !== oldValue) {
				this.otherStatementsItem = value;
			}
		},
	},
};
</script>

<style scoped lang="scss">
@import "StatementsAll.scss";
</style>
